import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { ChevronDownFilled } from '@fluentui/react-icons';
import { alpha, Button, Menu, MenuItem, styled, Typography } from '@mui/material';
const StyledMenu = styled((props) => (_jsx(Menu, { elevation: 0, anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, transformOrigin: { vertical: 'top', horizontal: 'right' }, ...props })))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': { padding: '4px 0' },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5)
            },
            '&:active': {
                backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300]
        })
    }
}));
const SButtonMenu = ({ handleChange, value, label, size = 'medium', options = [], isDisabled }) => {
    const [selectedLabel, setSelectedLabel] = useState(value);
    useEffect(() => {
        setSelectedLabel(value);
    }, [value]);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const onOptionClick = (option) => {
        setSelectedLabel(option.name);
        handleChange(option.value);
        handleClose();
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Button, { id: 'demo-customized-button', "aria-controls": open ? 'demo-customized-menu' : undefined, "aria-haspopup": 'true', "aria-expanded": open ? 'true' : undefined, variant: 'outlined', color: 'inherit', size: size, disableElevation: true, onClick: handleClick, disabled: isDisabled, endIcon: _jsx(ChevronDownFilled, { fontSize: 20 }), children: [_jsx(Typography, { variant: 'inherit', fontWeight: 500, fontSize: 13, color: 'textDisabled', children: label }), "\u00A0 ", selectedLabel] }), _jsx(StyledMenu, { id: 'demo-customized-menu', slotProps: {
                    list: {
                        'aria-labelledby': 'demo-customized-button'
                    }
                }, anchorEl: anchorEl, open: open, onClose: handleClose, children: options.map((option, idx) => (_jsx(MenuItem, { selected: option.name === selectedLabel, onClick: () => onOptionClick(option), disableRipple: true, children: option.name }, idx))) })] }));
};
export default SButtonMenu;
